import React from 'react';
import classNames from '../../../../utility/classNames';
import Tooltip from '../../../Tooltip';
import DropdownButton from '../../../buttons/DropdownButtonComponent';
import PositionBar from '../../../property-summaries/PositionBar';

export default function TwoColumnField({
  field,
  fieldValue,
  labelElement,
  percentToDisplay,
  monthlyToDisplay,
  annualToDisplay,
  handleDropDown,
  isDropDownOpen,
  hasBorder,
  showTopBorder,
  showBar = false,
}) {
  const { formula, dynamic, mainValue } = field;

  const numValues = [
    percentToDisplay,
    monthlyToDisplay,
    annualToDisplay,
  ].filter((x) => x !== null && x !== undefined).length;

  let dynamicClasses = '';
  if (dynamic) {
    if (field.red && field.green) {
      if (fieldValue < field.red) {
        dynamicClasses = 'text-red-700  font-semibold';
      }
      if (fieldValue > field.green) {
        dynamicClasses = 'text-green-700  font-semibold';
      }
    } else {
      dynamicClasses =
        fieldValue >= 0
          ? 'text-green-700  font-semibold'
          : 'text-red-700 font-semibold';
    }
  }

  const toolTipText =
    numValues > 1 ? (
      <div className="flex flex-col gap-1">
        {percentToDisplay && (
          <>
            <span className="font-semibold text-base">Percent</span>
            <span className="flex justify-center">
              {percentToDisplay || '-'}
            </span>
          </>
        )}
        {monthlyToDisplay && (
          <>
            <span className="font-semibold text-base">Monthly</span>
            <span className="flex justify-center">
              {monthlyToDisplay || '-'}
            </span>
          </>
        )}
        {annualToDisplay && (
          <>
            <span className="font-semibold text-base">Annual</span>
            <span className="flex justify-center">
              {annualToDisplay || '-'}
            </span>
          </>
        )}
      </div>
    ) : null;

  const mainValueToDisplay = () => {
    switch (mainValue) {
      case 'percent':
        return percentToDisplay;
      case 'monthly':
        return monthlyToDisplay;
      case 'annual':
        return annualToDisplay;
      default:
        return monthlyToDisplay;
    }
  };

  const mainValueElement = (
    <div className="text-lg">
      <div
        className={classNames(
          'relative sm:max-w-xs h-full flex pl-1 font-medium',
          formula ? 'justify-between' : 'justify-between sm:justify-end',
          field.showAnnualBrackets && annualToDisplay
            ? 'flex-col items-end'
            : 'items-center',
          (percentToDisplay || annualToDisplay) && '',
          dynamicClasses
        )}
      >
        <span
          className={classNames(
            'flex justify-end',
            formula && 'sm:justify-between'
          )}
        >
          {mainValueToDisplay() || '-'}
        </span>
        {field.showAnnualBrackets && annualToDisplay && (
          <span className="text-base font-normal">
            ({annualToDisplay}/year)
          </span>
        )}
      </div>
    </div>
  );

  return (
    <div
      className={classNames(
        'flex w-full justify-between sm:gap-4 lg:gap-1 xl:gap-3 pb-3 pt-2',
        field.dropDownDependency || field.subField
          ? 'border-l-[1px] border-l-neutral-100 mx-auto w-[87%] p-1 pl-3'
          : field.small
          ? '-mt-1 text-neutral-600'
          : '',
        !hasBorder && ' border-t-neutral-50',
        hasBorder && ' border-t-neutral-300',
        showTopBorder && 'border-t'
      )}
    >
      {/* Label for the field */}

      <div className="flex items-center gap-2 flex-1">
        <div>{labelElement}</div>
        {handleDropDown && (
          <DropdownButton
            buttonStyles={'mt-0.5 sm:p-0 text-primary-600'}
            textStyles={'text-sm'}
            setOpen={() => handleDropDown(field.name)}
            isOpen={isDropDownOpen}
          />
        )}
      </div>
      <div
        className={classNames(
          'flex items-center gap-3 flex-1',
          showBar && percentToDisplay ? 'justify-between' : 'justify-end'
        )}
      >
        {showBar && percentToDisplay && (
          <PositionBar location={percentToDisplay} />
        )}
        {toolTipText ? (
          <Tooltip
            text={toolTipText}
            heading={field.tooltipHeading}
            formula={field.tooltipFormula}
            offset={'-left-28 top-6'}
          >
            {mainValueElement}
          </Tooltip>
        ) : (
          mainValueElement
        )}
      </div>
    </div>
  );
}
